import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5232a7a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_header" }
const _hoisted_2 = { class: "account_info" }
const _hoisted_3 = { class: "invoice_month" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "年", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "月", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "請求分", -1))
const _hoisted_7 = { class: "remain_count" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "残り", -1))
const _hoisted_9 = { class: "count" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "件", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small-text" }, "（初月含む）", -1))
const _hoisted_13 = { key: 0 }

import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import Btn from "@/components/common/Btn.vue";
import Icon from "@/components/common/Icon.vue";
import ChangeOperatorModal from "../common/ChangeOperatorModal.vue";
import IrregularUpdateModal from "../common/IrregularUpdateModal.vue";
import { ICompanyInvoice } from "@/models/company-invoice";
import CompanyInvoiceApi from "@/api/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
  remainCompanyInvoices: ICompanyInvoice[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardHeader',
  props: {
    companyInvoice: {},
    remainCompanyInvoices: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

let isSubmitting = ref(true);
let countDown = ref(5)

onMounted(() => {
  const interval = setInterval(() => {
    countDown.value--
    if (countDown.value === 0) {
      clearInterval(interval)
      isSubmitting.value = false
    }
  }, 1000)
})



const state = reactive({
  visibleOperatorModal: false,
  visibleIrregularModal: false,
});

const closeOperatorModal = () => {
  state.visibleOperatorModal = false;
};

const openOperatorModal = () => {
  closeIrregularModal();
  state.visibleOperatorModal = true;
};

const closeIrregularModal = () => {
  state.visibleIrregularModal = false;
};

const openIrregularModal = () => {
  closeOperatorModal();
  state.visibleIrregularModal = true;
};

const onClickAccountName = (companyId: number) => {
  router.push({ name: "cs-company-edit", params: { id: companyId } });
};

const onClickChangeOperator = () => {
  console.log("onClickChangeOperator");
  openOperatorModal();
};

const onClickIrregularChangeOperator = () => {
  console.log("onClickIrregularChangeOperator");
  openIrregularModal();
};

const onClickOrderInvoice = async () => {
  isSubmitting.value = true
  await CompanyInvoiceApi.updateCompanyInvoiceStatusToBilled(
    props.companyInvoice.id
  ).then(() => {
    isSubmitting.value = false;
    // reload する
    location.reload();
  }, () =>{
    isSubmitting.value = false;
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", {
          class: "account_name",
          onClick: _cache[0] || (_cache[0] = () => onClickAccountName(_ctx.companyInvoice.company_id))
        }, [
          _createTextVNode(_toDisplayString(_ctx.companyInvoice.company_name) + " ", 1),
          _createVNode(Icon, {
            "icon-name": "icon_edit",
            "icon-circle": "",
            "class-name": "account_edit_icon"
          })
        ]),
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.companyInvoice.year), 1),
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.companyInvoice.month), 1),
          _hoisted_5,
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.remainCompanyInvoices.length + 1), 1),
        _hoisted_10
      ]),
      _createVNode(Btn, {
        text: "取引担当者を変更",
        "on-click-event": onClickChangeOperator,
        "btn-type": "btn-gray"
      }),
      _createVNode(Btn, {
        "btn-type": "btn-gray",
        "on-click-event": onClickIrregularChangeOperator
      }, {
        default: _withCtx(() => [
          _createTextVNode(" イレギュラーのため変更 "),
          _hoisted_11,
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(Btn, {
        "on-click-event": onClickOrderInvoice,
        disabled: _unref(isSubmitting)
      }, {
        default: _withCtx(() => [
          _createTextVNode(" この内容で請求書を発行依頼 "),
          (_unref(countDown) > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(_unref(countDown)) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(ChangeOperatorModal, {
      visible: state.visibleOperatorModal,
      "company-invoice": _ctx.companyInvoice,
      "on-close": closeOperatorModal
    }, null, 8, ["visible", "company-invoice"]),
    _createVNode(IrregularUpdateModal, {
      "company-invoice": _ctx.companyInvoice,
      visible: state.visibleIrregularModal,
      "on-close": closeIrregularModal
    }, null, 8, ["company-invoice", "visible"])
  ], 64))
}
}

})